import { axiosInstance } from "./";

const getNotifications = async (params, config) =>
  await axiosInstance.get(`/admin_portal_notifications`, { params, ...config });

const setNotificationSeen = async (id) =>
  await axiosInstance.patch(`/admin_portal_notifications/${id}`);

export { getNotifications, setNotificationSeen };
